const USER_STORAGE_KEY = 'mvc-user';

/**
 * Follows a logout that happened in another tab.
 *
 * Every tab on this origin shares `mvc-user`, but each one keeps its own copy of
 * the user in the store and authenticates from that copy. When another tab logs
 * out it removes `mvc-user`, and this tab would carry on looking logged in while
 * everything that reads the user back from storage (the RH attribution mode, the
 * preferences writes) finds nothing. Reloading lands it on the login page, the
 * same place the tab that logged out ends up.
 *
 * The storage event only fires in the other tabs, never in the one that made the
 * change, so the logout action's own reload is not doubled.
 */
const watchCrossTabLogout = (isLoggedIn: () => boolean) => {
    const handleStorage = (e: StorageEvent) => {
        // A null key means the whole storage was cleared.
        const userRemoved =
            (e.key === USER_STORAGE_KEY && e.newValue === null) ||
            (e.key === null && localStorage.getItem(USER_STORAGE_KEY) === null);
        if (userRemoved && isLoggedIn()) {
            window.location.reload();
        }
    };

    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
};

export default watchCrossTabLogout;
